import React from 'react'
import RoutesPage from './RoutesPage'
import AdsContext from './Components/UseContext/AdsContext'


const App = () => {
  return (
    <>
      <AdsContext>
        <RoutesPage />
      </AdsContext>
    </>
  )
}

export default App